var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.532.727c-.976 0-1.78.794-1.78 1.758v.592H.182v1.175h1.19v9.986c0 .968.804 1.762 1.785 1.762h7.14c.981 0 1.785-.794 1.785-1.762V4.252h1.19V3.077h-3.57v-.592c0-.964-.804-1.758-1.78-1.758h-2.39Zm0 1.175h2.39c.335 0 .59.252.59.583v1.767h2.38v9.986c0 .33-.26.587-.595.587h-7.14a.584.584 0 0 1-.595-.587V4.252h2.38V2.485c0-.33.256-.583.59-.583Z",
    fill: "#111"
  })));
};

export default SvgDelete;